/**
 * Named constants for Tailwind utility classes that embed inline SVG data
 * URLs. Each class string must live on a single line — Tailwind's scanner
 * matches literal class tokens in source and does not evaluate runtime
 * concatenation.
 *
 * Spaces inside the SVG are encoded as `%20` (not underscores). Tailwind
 * v4 does not reliably convert underscores back to spaces inside an
 * arbitrary-value `url()`, so leaving underscores there would produce
 * invalid SVG markup (`svg_viewBox=...`).
 */

// Hamburger menu icon used by the mobile navbar toggle.
// prettier-ignore
export const navbarTogglerIconClass = "inline-block w-6 h-6 align-middle bg-no-repeat bg-center bg-contain bg-[url('data:image/svg+xml,%3csvg%20viewBox=%270%200%2030%2030%27%20xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath%20stroke=%27rgba(0,0,0,0.5)%27%20stroke-width=%272%27%20stroke-linecap=%27round%27%20stroke-miterlimit=%2710%27%20d=%27M4%207h22M4%2015h22M4%2023h22%27/%3e%3c/svg%3e')]";

// Checkmark glyph used by the custom-checkbox indicator when :checked.
// prettier-ignore
export const customCheckboxCheckmarkUrlClass = "bg-[url('data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%208%208%22%3E%3Cpath%20fill=%22%23fff%22%20d=%22M6.564.75l-3.59%203.612-1.538-1.55L0%204.26%202.974%207.25%208%202.193z%22/%3E%3C/svg%3E')]";

// Double-chevron glyph used by the Bootstrap custom-select.
// prettier-ignore
export const customSelectChevronUrlClass = "bg-[url('data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%204%205%22%3E%3Cpath%20fill=%22%230e103e%22%20d=%22M2%200L0%202h4zm0%205L0%203h4z%22/%3E%3C/svg%3E')]";
